export const REGISTER_USER_START = 'REGISTER_USER_START';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const REGISTER_USER_END = 'REGISTER_USER_END';
export const RESTORE_REGISTER_USER = 'RESTORE_REGISTER_USER';
